export default {
  internalChatMessages: state => state.internalChatMessages,
  internalChatMessageInfos: state => state.internalChatMessageInfos,
  isSocketAlreadyListened: state => state.isSocketAlreadyListened,
  selectInternalChat: state => state.selectInternalChat,
  selectedInternalChats: state => state.selectInternalChat.chats,
  selectedInternalUserId: state => state.selectInternalChat.user_id,
  replyinternalChatMessage: state => state.replyinternalChatMessage,
}